"use strict";

exports.__esModule = true;
exports.ReportingPeriodSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
var _excluded = ["value", "translator", "onChange", "children"];
var _class, _ReportingPeriodSelector;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Allows users to select a reporting period.
 */
var ReportingPeriodSelector = exports.ReportingPeriodSelector = (0, _Translator.withTranslator)(_class = (_ReportingPeriodSelector = /*#__PURE__*/function (_Component) {
  function ReportingPeriodSelector() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClickShift = function () {
      return _this.props.onChange("shift");
    };
    _this.handleClickWorkday = function () {
      return _this.props.onChange("workday");
    };
    return _this;
  }
  _inheritsLoose(ReportingPeriodSelector, _Component);
  var _proto = ReportingPeriodSelector.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      value = _this$props.value,
      translator = _this$props.translator,
      onChange = _this$props.onChange,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var translate = translator.translate;
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, extra, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: value === "shift",
      onClick: this.handleClickShift
    }, translate("ReportingPeriodSelector.shift", "Shift")), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: value === "workday",
      onClick: this.handleClickWorkday
    }, translate("ReportingPeriodSelector.workday", "Workday")), children);
  };
  return ReportingPeriodSelector;
}(_react.Component), _ReportingPeriodSelector.defaultProps = {
  translator: undefined
}, _ReportingPeriodSelector)) || _class;